import { gql } from '@apollo/client';

const GET_UNREAD_MESSAGE_COUNT = gql`
  query getUnreadMessageCount {
    unreadMessageData(before: $before, clientId: $clientId, viewerId: $viewerId, group: $group)
      @rest(
        type: "UnreadMessageData"
        endpoint: "gateway"
        path: "messages/:clientId/unread/:viewerId?before=:before&group=:group&names=feed.message.created"
      ) {
      count: unreadMessageCount
    }
  }
`;

const GET_CLIENT_BOOKS_STATUSES = gql`
  query getClientBooksStatuses($clientId: String!) {
    clientBooksStatuses(clientId: $clientId)
      @rest(type: "ClientBooksStatus", path: "clientbookkeepingstatus.json/client/:clientId") {
      month
      clientBookkeepingStatus
    }
  }
`;

const GET_CLIENT_COMPANY = gql`
  query getClientCompany($clientId: ID!) {
    client(id: $clientId) {
      id
      company
    }
  }
`;

const GET_CLIENT_NOTIFICATIONS = gql`
  query getClientNotifications($personId: ID!, $args: String!) {
    notifications(id: $personId, args: $args)
      @rest(
        type: "ClientNotifications"
        endpoint: "gateway"
        path: "notifications/client/:id:args"
      ) {
      events @type(name: "Events") {
        full @type(name: "EventsDetails") {
          assets @type(name: "EventAssets") {
            assetType
            payload
            payloadName
            resource
            resourceId
          }
          context @type(name: "EventContext") {
            eventSource @type(name: "EventContextSource") {
              authorId
              authorRoles
              sourceType
            }
            personId
          }
          createdAt
          id
          name
        }
      }
    }
  }
`;

const DELETE_NOTIFICATION = gql`
  mutation deleteNotification($personId: ID!, $eventId: String!) {
    deleteNotification(personId: $personId, eventId: $eventId)
      @rest(
        endpoint: "gateway"
        method: "DELETE"
        path: "notifications/:personId/:eventId"
        type: "DeleteNotification"
      ) {
      NoResponse
    }
  }
`;

export {
  GET_UNREAD_MESSAGE_COUNT,
  GET_CLIENT_BOOKS_STATUSES,
  GET_CLIENT_COMPANY,
  GET_CLIENT_NOTIFICATIONS,
  DELETE_NOTIFICATION,
};
